import { memo } from 'react';
import { FastField } from 'formik';
import { fieldToUpload, UploadBase } from './UploadBase';
import type { UploadBaseProps } from './UploadBase';

export const ImageUpload = memo<UploadBaseProps>(({ name, ...restProps }) => (
  <FastField name={name}>
    {(props) => {
      const error = props.form.errors && props.form.errors[name];
      const isTouched = props.form.touched && props.form.touched[name];

      return (
        <UploadBase
          name={name}
          {...fieldToUpload(props)}
          {...restProps}
          error={isTouched && error}
        />
      );
    }}
  </FastField>
));
